/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPortefeuille } from '../fn/portefeuille-v-2-controller/get-portefeuille';
import { GetPortefeuille$Params } from '../fn/portefeuille-v-2-controller/get-portefeuille';
import { getPortefeuilleV2 } from '../fn/portefeuille-v-2-controller/get-portefeuille-v-2';
import { GetPortefeuilleV2$Params } from '../fn/portefeuille-v-2-controller/get-portefeuille-v-2';
import { GetSitePortefeuilleResponseDto } from '../models/get-site-portefeuille-response-dto';

/**
 * Récupérer du portefeuille pour un intervenant.
 */
@Injectable({ providedIn: 'root' })
export class PortefeuilleV2ControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPortefeuilleV2()` */
  static readonly GetPortefeuilleV2Path = '/v2/portefeuille/{id_intervenant}';

  /**
   * post.
   *
   * Récupération de la liste des sites pour alimenter le portefeuille du technicien
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPortefeuilleV2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPortefeuilleV2$Response(
    params: GetPortefeuilleV2$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<GetSitePortefeuilleResponseDto>>> {
    return getPortefeuilleV2(this.http, this.rootUrl, params, context);
  }

  /**
   * post.
   *
   * Récupération de la liste des sites pour alimenter le portefeuille du technicien
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPortefeuilleV2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPortefeuilleV2(
    params: GetPortefeuilleV2$Params,
    context?: HttpContext
  ): Observable<Array<GetSitePortefeuilleResponseDto>> {
    return this.getPortefeuilleV2$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<Array<GetSitePortefeuilleResponseDto>>): Array<GetSitePortefeuilleResponseDto> => r.body
      )
    );
  }

  /** Path part for operation `getPortefeuille()` */
  static readonly GetPortefeuillePath = '/v2/portefeuilles/{id_intervenant}';

  /**
   * get.
   *
   * Récupération de la liste des sites du périmètre du technicien pour alimenter le portefeuille du technicien
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPortefeuille()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortefeuille$Response(
    params: GetPortefeuille$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<GetSitePortefeuilleResponseDto>>> {
    return getPortefeuille(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récupération de la liste des sites du périmètre du technicien pour alimenter le portefeuille du technicien
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPortefeuille$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortefeuille(
    params: GetPortefeuille$Params,
    context?: HttpContext
  ): Observable<Array<GetSitePortefeuilleResponseDto>> {
    return this.getPortefeuille$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<Array<GetSitePortefeuilleResponseDto>>): Array<GetSitePortefeuilleResponseDto> => r.body
      )
    );
  }
}
